export function getRandomInt() {
  const max = 10
  const min = 1
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function getRandomCalculatSign() {
  const signs = ['+', '-', '*']
  return signs[Math.floor(Math.random() * signs.length)]
}

export const numberInLetters = new Map([
  [1, 'un'],
  [2, 'deux'],
  [3, 'trois'],
  [4, 'quatre'],
  [5, 'cinq'],
  [6, 'six'],
  [7, 'sept'],
  [8, 'huit'],
  [9, 'neuf'],
  [10, 'dix'],
])

/**
 * round a number to the nearest 1000
 */
export function roundNumberToK(value: number): number {
  return Math.ceil(value / 1000) * 1000
}

/**
 * Define a function generateRoundedRange that takes two parameters: min and max.
Initialize an empty array to store the rounded numbers.
Use a loop to iterate from the minimum value to the maximum value, rounding each number to the nearest thousand.
Add each rounded number to the array if it is not already present.
Return the array of rounded numbers.
 */
export function generateRoundedRange(min: number, max: number): number[] {
  const roundedNumbers: number[] = []
  const start = Math.ceil(min / 10) * 10
  const end = Math.floor(max / 10) * 10

  for (let i = start; i <= end; i += 1) {
    roundedNumbers.push(i)
  }

  return roundedNumbers
}
